import React, { useState } from 'react'
import { Input, Tooltip } from 'antd'

export const ClickTextEdit = ({ onSave, defaultValue, display, placeholder, name }) => {
  const [isEditing, setIsEditing] = useState()
  const [status, setStatus] = useState()

  return (
    <Tooltip title={isEditing ? 'Enter to Save' : 'Click to Edit'}>
      <div
        className='hover-text-edit flex-1 pl-2'
        onClick={(e) => {
          e.stopPropagation()
          setIsEditing(true)
        }}
      >
        {isEditing ? (
          <Input
            onChange={(e) => setStatus(isNaN(e.target.value) ? 'error' : '')}
            style={{ fontSize: '0.95em', width: '90%', marginLeft: '0.5em', height: 24 }}
            defaultValue={defaultValue}
            name={name}
            placeholder={placeholder}
            status={status}
            onPressEnter={(e) => {
              onSave(e)
              setIsEditing(false)
            }}
          />
        ) : (
          display
        )}
      </div>
    </Tooltip>
  )
}
